module.exports = __webpack_public_path__ + "img/wav.c4680d84.svg";